import React, { useContext, useMemo } from 'react';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { ThemeContext } from '../../context/ThemeContext';
import '../../App.scss';

const ContrySelect = ({ value, onChange, placeholder }) => {
    const { darkMode } = useContext(ThemeContext);

    const options = useMemo(() => {
        return countryList().getData().map((country) => ({
            value: country?.value,
            label: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img src={`https://flagcdn.com/w40/${country?.value.toLowerCase()}.png`} alt={country?.label} style={{ width: 20, height: 14, objectFit: 'contain' }} />
                    {country?.label}
                </div>
            )
        }));
    }, []);

    const customStyles = {
        control: (provided) => ({ ...provided, height: 30, boxShadow: 'none', border: `1px solid ${darkMode ? 'var(--borderDark)' : 'var(--borderLight)'}`, backgroundColor: darkMode ? 'var(--background-color)' : 'var(--white)', }),
        placeholder: (provided) => ({ ...provided, fontSize: '14px', fontFamily: 'Trebuchet MS, Roboto, Ubuntu, sans-serif' }),
        valueContainer: (provided) => ({ ...provided, padding: '0 10px', }),
        singleValue: (provided) => ({ ...provided, fontSize: '14px' }),
        menu: (provided) => ({ ...provided }),
        option: (provided, state) => ({ ...provided, fontFamily: 'Trebuchet MS, Roboto, Ubuntu, sans-serif', fontSize: '14px', backgroundColor: darkMode ? "#273649" : 'var(--white)', color: darkMode ? "var(--lightText)" : 'var(--darkText)', }),
    };
    return (
        <Select styles={customStyles} options={options} value={value} onChange={onChange} placeholder={placeholder} />
    );
};

export default ContrySelect;
